import React from 'react';

import {
  Box,
} from '@mui/material';

import { SystemManagement    } from './components/SystemManagement/SystemManagement';
import { ProkeyGeneralPanel, ProkeyStatsPanel } from './components/ProkeyStatsPanel/ProkeyStatsPanel';
import { SystemResourcePanel } from './components/SystemResourcePanel/SystemResourcePanel';

//-----------------------------------------------------------------
export function ServerPanel() {
  //-----------------------------------------------------------------

  //#region [STYLES]

  const _styles = {
    container: {
      height  : '100%' ,
    },
    top_row: {
      display : 'flex' ,
      gap     : '1rem' ,
      height  : '25rem' ,
    },
    worker_row: {
      display   : 'flex' ,
      gap       : '1rem' ,
      height    : '25rem' ,
      marginTop : '1rem'  ,
    }
  }

  const CONTAINER = {
    sx : _styles.container,
  }
  const TOP_ROW = {
    sx : _styles.top_row,
  }
  const WORKER_ROW = {
    sx : _styles.worker_row,
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <Box { ...TOP_ROW } >
          <SystemManagement />
          <ProkeyGeneralPanel />
        </Box>
        <Box { ...WORKER_ROW } >
          <ProkeyStatsPanel />
        </Box>
        <SystemResourcePanel />
      </Box>
    );
  }

  //#endregion

  return display();
}
